import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import RawLazyLoad from 'react-lazy-load';
import {
  TinyTitle,
  TinyText,
  Lowercase,
  Anchor,
  BaseLink
} from './CommonUiComponents';
import { textGray } from '../utils/colors';
import lion from '../utils/images/lions-logo.png';
import logo from '../utils/images/logo_pos.png';
import dmv from '../utils/images/dmv-stiftelsen.png';

const StyledFooter = styled.footer`
  padding: 1.5rem 0;
  margin: 2rem 0 2rem 2.5rem;

  @media screen and (max-width: 72rem) {
    margin-left: 0;
  }
`;

const Content = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media screen and (max-width: 72rem) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  @media screen and (max-width: 40rem) {
    padding: 0 1.5rem;
  }
`;

const Column = styled.div`
  margin: 2.5rem;

  > div {
    display: inline-block;

    &:first-child {
      margin-right: 5rem;

      @media screen and (max-width: 40rem) {
        margin: 0;
      }
    }
  }

  ${props =>
    props.right &&
    css`
      @media screen and (min-width: 72rem) {
        margin-left: auto;
        padding-left: 2.5rem;
      }

      @media screen and (max-width: 72rem) {
        width: 100%;
      }
    `};

  > ${TinyText} {
    margin: 1.375rem 0;
  }

  @media screen and (max-width: 72rem) {
    margin: 1.5rem;

    &:first-child {
      margin: 2.5rem;
    }

    &:last-child {
      margin: 2.5rem;
    }
  }

  @media screen and (max-width: 40rem) {
    margin: 1rem 0;

    &:first-child {
      margin: 0;
    }

    &:last-child {
      margin: 0;
    }
  }
`;

const MyChoice = styled.img`
  height: 2rem;
`;

const Lion = styled.img`
  width: 1.3rem;
  margin-right: 0.2rem;
`;

const DmvS = styled.img`
  width: 1.3rem;
  margin-left: 0.2rem;
  color: ${textGray};

  ${props =>
    props.inverted &&
    css`
      color: #fff;
    `};
`;

const DmvText = styled.span`
  position: relative;
  top: -0.3rem;
  text-transform: uppercase;
  font-size: 0.8rem;
  color: ${textGray};

  ${props =>
    props.inverted &&
    css`
      color: #fff;
    `};
`;

const LazyLoad = styled(RawLazyLoad)`
  display: inline-block;
`;

const Footer = ({ inverted, bookId }) => (
  <StyledFooter>
    <Content>
      <Column>
        <LazyLoad>
          <BaseLink to={`/bok/${bookId}`}>
            <MyChoice src={logo} alt="Mitt Valg!" />
          </BaseLink>
        </LazyLoad>
      </Column>
      <Column>
        <div>
          <DmvText inverted={inverted}>Stiftelsen det er mitt valg</DmvText>
          <LazyLoad>
            <DmvS src={dmv} alt="Stiftelsen det er mitt valg" />
          </LazyLoad>
        </div>
        <div>
          <LazyLoad>
            <Lion src={lion} alt="Et lions-program" />
          </LazyLoad>
          <DmvText inverted={inverted}>Et lions-program</DmvText>
        </div>
      </Column>
      <Column right>
        <TinyTitle inverted={inverted}>
          Ønsker du å vite mer om MITT VALG?<br />
          <Lowercase>
            Gå inn på{' '}
            <Anchor
              href="https://determittvalg.no"
              target="_blank"
              rel="noopener"
            >
              determittvalg.no
            </Anchor>
          </Lowercase>
        </TinyTitle>
        <TinyText inverted={inverted}>
          Copyright 2017 Stiftelsen DET ER MITT VALG
        </TinyText>
      </Column>
    </Content>
  </StyledFooter>
);

Footer.propTypes = {
  inverted: PropTypes.bool,
  bookId: PropTypes.number
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js